import React from "react"
import ContentLoader from "react-content-loader"

const Skeleton = (props) => (
 <div className="skeleton"v>
      <ContentLoader
        width="100%"
        backgroundColor="rgba(255,255,255,.06)"
        foregroundColor="rgba(255,255,255,.03)"
        // backgroundColor="#f3f3f3"
        // foregroundColor="#ecebeb"
        {...props}
    >
        <rect x="1" y="-8" rx="3" ry="3" width="100%" height="200" />
    </ContentLoader>
 </div>
)

export default Skeleton